import React from "react";
import { Button } from "aible";

import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class CreateConsultantModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      subTitle: "",
      textBody: "",
      cHoursAgo: 0,
      contractType: "",
      contractLength: ""
    };
  }

  componentDidUpdate(prevProps) {
    const { isCreateConsultant } = this.props;

    if (
      isCreateConsultant !== undefined &&
      isCreateConsultant !== false &&
      prevProps.isCreateConsultant === false &&
      isCreateConsultant !== true
    ) {
      this.setState({
        id: isCreateConsultant.id,
        title: isCreateConsultant.title,
        subTitle: isCreateConsultant.subTitle,
        textBody: isCreateConsultant.textBody,
        cHoursAgo: isCreateConsultant.cHoursAgo,
        contractType: isCreateConsultant.contractType,
        contractLength: isCreateConsultant.contractLength
      });
    } else if (isCreateConsultant === true && prevProps.isCreateConsultant === false) {
      this.setState({
        id: undefined,
        title: "",
        subTitle: "",
        textBody: "",
        cHoursAgo: "",
        contractType: "",
        contractLength: ""
      });
    }
  }

  render() {
    const { isCreateConsultant, updateIsCreateConsultant, createConsultant } = this.props;
    const { id, title, subTitle, textBody, contractType, contractLength } = this.state;

    const contractTypes = ["Data Exploration", "Data Exploration / AI Creation", "AI Creation / Deployment"];
    const contractLengths = ["1 Month", "2 Month", "3 Month", "6 Month", "Part Time"];

    return (
      <Dialog open={isCreateConsultant !== false} onOpenChange={() => updateIsCreateConsultant(false)}>
        <DialogContent size="sm">
          <DialogHeader>
            <DialogTitle>
              {id !== undefined ? "Edit Consulting Opportunity" : "Create a new Consulting Opportunity"}
            </DialogTitle>
          </DialogHeader>
          <div>
            <div className={styles.jobInput}>
              <div>{"Name: "}</div>
              <div>
                <LineInput isMediumBox onChange={(val) => this.setState({ title: val })} value={title} />
              </div>
            </div>
            <div className={styles.jobInput}>
              <div>{"Company: "}</div>
              <div>
                <LineInput isMediumBox onChange={(val) => this.setState({ subTitle: val })} value={subTitle} />
              </div>
            </div>
            <div className={styles.jobInput}>
              <div>{"Contract Type: "}</div>
              <div>
                <Select
                  options={contractTypes.map((t) => ({ value: t, label: t }))}
                  onChange={(val) => this.setState({ contractType: val.value })}
                  value={
                    contractTypes.find((t) => t === contractType)
                      ? {
                          value: contractTypes.find((t) => t === contractType),
                          label: contractTypes.find((t) => t === contractType)
                        }
                      : undefined
                  }
                />
              </div>
            </div>
            <div className={styles.jobInput}>
              <div>{"Contract Length: "}</div>
              <div>
                <Select
                  options={contractLengths.map((t) => ({
                    value: t,
                    label: t
                  }))}
                  onChange={(val) => this.setState({ contractLength: val.value })}
                  value={
                    contractLengths.find((t) => t === contractLength)
                      ? {
                          value: contractLengths.find((t) => t === contractLength),
                          label: contractLengths.find((t) => t === contractLength)
                        }
                      : undefined
                  }
                />
              </div>
            </div>
            <div className={styles.jobInput}>
              <div>{"Description: "}</div>
              <div>
                <LineInput isMediumBox onChange={(val) => this.setState({ textBody: val })} value={textBody} />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button type="secondary" onClick={() => updateIsCreateConsultant(false)} style={{ marginRight: "auto" }}>
              {"Close"}
            </Button>
            <Button type="primary" onClick={() => createConsultant({ ...this.state })}>
              {id !== undefined ? "Update" : "Create"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
